export default class DateUtils {
  /**
   * Formats any date (in ms or Date object) into
   * ISO format.
   *
   * Example:
   *  pass:   1582456036830
   *  return: 2020-Feb-23
   *
   *
   * @param {string} dateInMs
   * @return {string}
   */
  public static formatDateIntoInternational(dateInMs: string): string {
    const isoDate = new Date(Number(dateInMs)).toISOString().slice(0, 10);
    const [year, month, day] = isoDate.split('-');
    return `${year}-${this.getMonthByNumber(Number(month))}-${day}`;
  }

  public static getMonthByNumber = (monthNumber: number): string => {
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return monthNames[monthNumber];
  };
}
